import {FC} from 'react'

type Props = {
  label: string
  start: string
  end: string
  onChangeStart: (value: string) => void
  onChangeEnd: (value: string) => void
}

const isRangeInvalid = (start?: string, end?: string): boolean =>
  !!start && !!end && start.length === 10 && end.length === 10 && start > end

const DateRangeFilter: FC<Props> = ({label, start, end, onChangeStart, onChangeEnd}) => {
  const invalid = isRangeInvalid(start, end)

  return (
    <div className='mb-5 row'>
      <div className='col-6'>
        <label className='form-label fs-6 fw-bold'>{label}: Inicial</label>
        <input
          type='date'
          className='form-control form-control-solid'
          value={start}
          onChange={(e) => onChangeStart(e.target.value)}
          min='2015-12-31'
        />
        {invalid && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block fs-6'>Data inicial deve ser menor que data final</div>
          </div>
        )}
      </div>
      <div className='col-6'>
        <label className='form-label fs-6 fw-bold'>{label}: Final</label>
        <input
          type='date'
          className='form-control form-control-solid'
          value={end}
          onChange={(e) => onChangeEnd(e.target.value)}
          min='2015-12-31'
        />
      </div>
    </div>
  )
}

export {DateRangeFilter, isRangeInvalid}
